import React, {useEffect, useRef, useState} from "react";
import {Col, Progress, Row} from "antd";
import {
  LoadingContent,
  LoadingWrapper,
  LodingInnerWrapper,
  ProgressContent,
  ProgressWrapper,
  RemainingMinutesWrapper,
} from "./styles";
import LoadingImg from "./../../assets/loading.svg";
import {Tag} from "../../styles";
import {useDispatch} from "react-redux";
import appActions from "../../modules/app/appActions";
import moment from "moment";
import {Link, useHistory} from "react-router-dom";
import axios from "axios";

const Processing = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [job, setJob] = useState({});
  const [startTrans] = useState(moment().format('YYYY-MM-DD hh:mm:ss'));
  const [percent, setPercent] = useState(0.0);
  const [remainingTimeString, setRemainingTimeString] = useState('');
  useInterval(() => {
    if (job.status === 'complete') {
      history.replace(`/blog/${props.match.params.id}`)
    }
  }, 500)
  useInterval(async () => {
    try {
      const response = await axios.get(`https://api.tube2blog.com:5000/job/${props.match.params.id}`)
      console.log(response)
      if(response.status === 200){
        setJob(response.data)
        const p = (Math.round((response.data.percent > 0.99 ? 0.99 : response.data.percent)  * 100 * 100) / 100).toFixed(0);
        setPercent(p)
      }
    }catch (e) {
      console.log(e)
    }
    
  }, 5000);

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }

      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  const renderToolTipRow = (number, text) => (
    <>
      <Col xs={2}>
        <Tag
          style={{fontSize: 10}}
          type="primary"
          on
        >{number}
        </Tag>
      </Col>

      <Col xs={22} className={'transcript-segment'}>
        <span style={{color: '#7C82A7', textAlign: 'left', fontSize: 14}}>{text}</span>
      </Col>
    </>
  )
  console.log('id', props.match.params.id)
  return (
    <LoadingWrapper>
      <LodingInnerWrapper>
        <LoadingContent>
          <h2>
            Preparing Your Blog Post!
          </h2>
          <p className="" style={{width: 700, padding: 0, margin: 'auto'}}>
            When the page loads you’ll see two panels. The left is AI generated content based on the keyword themes in your video. The right panel is your ‘blog-fromatted’ transcript. Copy the left content into the right and edit till your hearts content!
          </p>
        </LoadingContent>
        <img
          alt={'loading'}
          src={LoadingImg}
          style={{
            position: 'absolute',
            top: 120,
            left: 0,
            right: 0,
            margin: 'auto',
            width: '100%'
          }}/>
        <ProgressWrapper>
          <ProgressContent>
            <h3 style={{fontSize: 25, marginTop: 25}}>Loading...</h3>
            <Row style={{marginBottom: 30}}>
              <span>Our monkeys are smashing their typewriters!!</span>
            </Row>
            
            <RemainingMinutesWrapper>
              {job.status ? job.status.toUpperCase() : 'Your job is in Queue'.toUpperCase()}
            </RemainingMinutesWrapper>
            <Progress percent={percent} showInfo={true}/>
            <div style={{color: '#252525', fontSize: 14, whiteSpace: 'pre-wrap', marginTop: 20, marginBottom: 20}}>
              {/*{`Please wait for your transcript to finish! You can leave this page\nand go to `}
              <Link to="/dashboard/transcriptions">Dashboard</Link>
              {` - we will email you when the transcript is ready!`}*/}
            </div>
          </ProgressContent>
        </ProgressWrapper>
      </LodingInnerWrapper>
    </LoadingWrapper>
  );
};

export default Processing;
